package com.gastoncantera.intercom

import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.ComposeViewport

@OptIn(ExperimentalComposeUiApi::class)
fun main() {
    initializeFirebase()
    // Compose 1.11+ vacía el contenedor. Si es <body>, se lleva el div de reCAPTCHA.
    ComposeViewport("compose-root") {
        App()
    }
}